import IProjectOutput from "@/api/models/IProjectOutput";
import IOrderOutput from "@/api/models/IOrderOutput";

export default (project: IProjectOutput, order: IOrderOutput) => {
  const d = new FormData();
  d.append("project[id]", project.id);
  d.append("project[name]", project.name);
  if (project.iconFile) {
    d.append("project[icon]", project.iconFile);
  }
  d.append("project[start]", project.start);
  d.append("project[end]", project.end);
  d.append("project[postcode]", project.postcode);
  d.append("project[address]", project.address);
  d.append("project[latitude]", String(project.latitude));
  d.append("project[longitude]", String(project.longitude));
  d.append("project[projectStatusId]", String(project.state));
  d.append("project[note]", project.note);
  d.append("project[tgId]", project.tgId);
  d.append("project[sSystemId]", project.sSystemId);
  d.append("project[OHANo]", project.OHANo);
  d.append("project[holdOut]", String(project.holdOut));
  d.append("project[closed]", String(project.closed));
  d.append("order[id]", order.id);
  d.append("order[officeId]", order.clientId);
  d.append("order[staffId]", order.clientStaffId);
  d.append("order[state]", String(order.state));
  if (project.templateId) {
    d.append("project[templateId]", String(project.templateId));
  }
  d.append("project[beforeTemplateId]", String(project.beforeTemplateId));
  project.additionalProperties.forEach((property, i) => {
    d.append(`project[additionalProperties][${i}][keyId]`, property.key.id);
    d.append(`project[additionalProperties][${i}][value]`, property.value);
  });
  return d;
};
